declare namespace $ {

	export class $bog_builderui_button extends $mol_button_minor {
		minimal_height( ): number
		minimal_width( ): number
		variant( ): string
		attr( ): ({ 
			'bog_builderui_button_variant': ReturnType< $bog_builderui_button['variant'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
	}
	
}

//# sourceMappingURL=button.view.tree.d.ts.map